// extracted by mini-css-extract-plugin
export default {"loading_container":"styles_loading_container__1za-F","loading_spinne":"styles_loading_spinne__OkNpD","spin":"styles_spin__yVcG2"};